// import { colorPrimary, textMenuColor } from 'common/theme'
import { zIndex } from 'common/constants'
import { gridBreakPoints } from 'common/theme'
import styled from 'styled-components'

export const StyledSubMenu = styled.div<{ isSticky?: boolean; assetFolder?: string }>`
  box-shadow: 0 0.3rem 0.4rem rgba(0, 0, 0, 0.15);
  border-radius: 0.3rem;
  background: ${({ isSticky, assetFolder, theme }) => {
    if (isSticky) {
      return theme.headerSticky.subMenuBackground
    }
    return theme.headerNotSticky.subMenuBackground
  }};
  position: absolute;
  font-size: 1.4rem;
  opacity: 0;
  transform: translateY(4rem);
  pointer-events: none;
  transition: all 167ms ease-in;
  z-index: ${zIndex.subMenu};

  &:hover {
    display: block;
  }

  svg {
    margin-right: 1rem;
  }

  .nav-item .nav-link {
    font-size: 1.6rem;
    margin-left: 0;
    margin-right: 0;
  }

  li {
    height: 4.2rem;
    transition: 167ms ease-in;
    border-bottom: 0.2rem solid transparent;
    line-height: 2.2;
  }

  li:hover {
    border-bottom: 0.2rem solid
      ${({ isSticky, theme, assetFolder }) => {
        if (isSticky) {
          return theme.headerSticky.subMenuItemBorder
        }
        return theme.headerNotSticky.subMenuItemBorder
      }};
  }

  @media (max-width: ${gridBreakPoints.lg}) {
    box-shadow: none;
    border-radius: unset;
    transition: none;
    transform: unset;
    opacity: unset;
    position: unset;
    background: transparent;
    li:hover {
      border-bottom: 0.2rem solid transparent;
    }
  }
`

export const StyledSubMenuItem = styled.li<{ isSticky?: boolean; assetFolder?: string }>`
  white-space: nowrap;
  a.nav-link:hover {
    //change nav link hover color: ;
    color: ${({ isSticky, theme }) => {
      if (isSticky) {
        return theme.headerSticky.subMenuItemHover
      }
      return theme.headerNotSticky.subMenuItemHover
    }};
    svg {
      fill: ${({ isSticky, theme }) => {
        if (isSticky) {
          return theme.headerSticky.subMenuItemHover
        }
        return theme.headerNotSticky.subMenuItemHover
      }};
    }
  }

  a.nav-link.active:after {
    border-bottom-color: transparent !important;
    border-top-color: transparent !important;
  }
`
